export const SUCCESS_ALERT = "SUCCESS_ALRET";
export const WARNING_ALERT = "WARNING_ALERT";
export const ERROR_ALERT = "ERROR_ALERT";
export const INFO_ALERT = "INFO_ALERT";
